import React, { useEffect, useState, useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import styles from './StatsConcert.module.css';
import img from '../assets/5.jpg';

const CountUp = ({ to, duration = 1.5 }) => {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.5 });

  useEffect(() => {
    if (inView) {
      let start = 0;
      const end = parseInt(to.replace(/[^\d]/g, ''), 10);
      if (start === end) return;

      const incrementTime = (duration * 1000) / end;
      
      const timer = setInterval(() => {
        start += 1;
        setCount(start);
        if (start === end) clearInterval(timer);
      }, incrementTime);

      return () => clearInterval(timer);
    }
  }, [inView, to, duration]);

  return <span ref={ref}>{count}{to.replace(/[\d]/g, '')}</span>;
};

const StatsConcert = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  
  const yParallax = useTransform(scrollYProgress, [0, 1], ['-20%', '20%']);
  const scaleBg = useTransform(scrollYProgress, [0, 1], [1.1, 1]);

  return (
    <section ref={ref} className={styles.section}>
      <motion.div 
        className={styles.bg}
        style={{ 
          backgroundImage: `url(${img})`,
          y: yParallax,
          scale: scaleBg
        }}
      />
      <div className={styles.overlay} />

      <div className={styles.container}>
        <div className={styles.statsRow}>
          <div className={styles.statItem}>
            <div className={styles.statValue}>
              <CountUp to="110 dB" duration={1.5} />
            </div>
            <div className={styles.statLabel}>
              A live concert.<br/>Potentially harmful after 2 minutes.
            </div>
          </div>
          
          <div className={styles.divider} />
          
          <div className={styles.statItem}>
            <div className={styles.statValue}>
              <CountUp to="85 dB" duration={1.5} />
            </div>
            <div className={styles.statLabel}>
              Heavy city traffic.<br/>Safe for under 2 hours.
            </div>
          </div>
          
          <div className={styles.divider} />
          
          <div className={styles.statItem}>
            <div className={styles.statValue}>
              <CountUp to="40 dB" duration={1.5} />
            </div>
            <div className={styles.statLabel}>
              A quiet park.<br/>Perfectly healthy.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsConcert;
